import { render } from "./progress_button.vue?vue&type=template&id=9f751ae6"
import script from "./progress_button.vue?vue&type=script&lang=js"
export * from "./progress_button.vue?vue&type=script&lang=js"

import exportComponent from "/Users/lainsoykaf/repos/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__